<template>
  <titled-section-panel class="pr">
    <template slot="header">PR <icon-new-window class="pr__icon"/></template>
    <template slot="body">
      <div class="frame">
        <div :id="frameId"/>
      </div>
    </template>
  </titled-section-panel>
</template>

<script>
import loadGooglePublisherTag from '@/mikan/_shared/lib/utilities/loadGooglePublisherTag';
import TitledSectionPanel from '@/mikan/_shared/components/molecules/TitledSectionPanel.vue';
import IconNewWindow from '@/mikan/_shared/components/atoms/icons/IconNewWindow.vue';

// MPAなのでフロントでadのidに関しての調停はまだ行わない
const AD_UNIT_PATH = '/13539712/EBISU_menu_bottom_pc';
const FRAME_ID = 'div-gpt-ad-1473939927149-0';

export default {
  components: {
    TitledSectionPanel,
    IconNewWindow,
  },
  computed: {
    frameId() {
      return FRAME_ID;
    },
  },
  async mounted() {
    try {
      await loadGooglePublisherTag();
      this.loadAd(window.googletag);
    } catch (error) {
      // TODO: エラー処理なんかする
      console.error(error);
    }
  },
  methods: {
    // TODO: 他にadを使うコンポーネントが現れたら抽象コンポーネントにする
    loadAd(googletag) {
      googletag.cmd.push(() => {
        googletag.defineSlot(AD_UNIT_PATH, [210, 175], FRAME_ID).addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      googletag.cmd.push(() => {
        googletag.display(FRAME_ID);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.pr {
  &__icon {
    color: $color-navy-20;
    font-size: 10px;
  }
}

.frame {
  display: flex;
  justify-content: center;
}
</style>
